/**
 * Annotation types
 * Separated to avoid circular dependencies between AnnotationCanvas and Context providers
 */

import { BoundingBox } from "../utils/annotationStrategies/BoundingBox";

export type Annotation = BoundingBox & {
    fileId: string;
    frameId: string;
    frameSegment?: number;
    empty?: boolean;
    confidence?: number;
};

/**
 * Controls which data source the AnnotationCanvas renders.
 * - Predictions: model-generated draft predictions
 * - Annotations: user-drawn annotations
 */
export enum AnnotationSource {
    Predictions = "predictions",
    Annotations = "annotations"
}

export function isAnnotationVisible(
    annotation: Pick<Annotation, "label" | "confidence">,
    promptLabels: Map<string, { hasDiffs?: boolean; confidenceThreshold?: number }>
): boolean {
    const promptLabel = promptLabels.get(annotation.label);
    if (!promptLabel) return false;
    if (promptLabel.hasDiffs) return true;
    return (
        !annotation.confidence ||
        !promptLabel.confidenceThreshold ||
        annotation.confidence >= promptLabel.confidenceThreshold
    );
}
